import ProcessingSoldHeader from "./Header";
import "./index.css";
import { useState } from "react";
import ProcessingNoDataContents from "./ProcessingNoData";
import WasteGeneratedContents from "./WasteGenerated";
import ProcessingDataContents from "./ProcessingData";
import { ShowHide } from "../components/ShowHideCompany";
import FlowNumbersBox from "../components/FlowNumbersBox";
import EPRBox from "../components/EPRBox";
const ProcessingIntermediateComponent = ({ businessId, mainBusinessId }) => {
  const [show, setShow] = useState(false);
  return (
    <div className="processing-sold-container" id="processing-id">
      <ProcessingSoldHeader businessId={businessId} show={show} />
      <div style={{ display: "flex", alignItems: "center" }}>
        <ShowHide show={show} setShow={setShow} />
        {show && (
          <EPRBox
            businessId={businessId}
            mainBusinessId={mainBusinessId}
            category={"Processing Sold Intermediate"}
          />
        )}
        <div style={{ position: "absolute", bottom: "30px", right: "14%" }}>
          <FlowNumbersBox
            isNormal={true}
            number={"Flow 16"}
            color={"#193666"}
          />
        </div>
      </div>
      {show && <ProcessingNoDataContents businessId={businessId} />}
      {show && <ProcessingDataContents businessId={businessId} />}
      {show && <WasteGeneratedContents businessId={businessId} />}
    </div>
  );
};

export default ProcessingIntermediateComponent;
